<div mat-dialog-title>{{ data.title }}</div>
<mat-dialog-content> 
  <div *ngIf="data.loadSpecificContent === 'text'" [innerHTML]="data.content"></div>
  <div *ngIf="data.loadSpecificContent === 'canvas'" 
     class="preview-image" 
     style="position: relative;">
    <canvas width="500" height="500" #hiddenCanvas></canvas>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close class="btn-back">
    {{ data.cancelText ? data.cancelText : (isLoginPopup ? ('COMMON_DIALOG.MAYBE_LATER' | translate) : ('COMMON_DIALOG.BACK' | translate)) }}
  </button>
  <button 
    *ngIf="data.loadSpecificContent !== 'canvas'" 
    mat-button 
    mat-dialog-close 
    class="btn-continue" 
    cdkFocusInitial 
    (click)="onNavigate()"
  >
    {{ data.confirmText ? data.confirmText : (isLoginPopup ? ('COMMON_DIALOG.LOGIN_NOW' | translate) : ('COMMON_DIALOG.CONFIRM' | translate)) }}
  </button>
</mat-dialog-actions>